module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rQRHGs/tc-custom/9781569759561.jpg?1737781390591",
      "alt": "This image is the cover for the book Foam Roller Workbook"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Foam Roller Workbook\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Amplify your stretches and exercises and prevent and rehabilitate injuries with these foam roller workouts from the bestselling health and fitness author.")]), _c('br'), _c('br'), _vm._v("Once used exclusively in physical therapy settings, the foam roller has made its way into yoga and pilates studios, gyms and homes. With this simple device, you can:Improve core strengthIncrease flexibilityRelease tensionAlleviate painRehabilitate injuries"), _c('br'), _c('br'), _c('i', [_vm._v("Foam Roller Workbook")]), _vm._v(" offers fifty effective exercises paired with clear captions and step-by-step photos that will help you roll your way to better posture, balance and relaxation. In addition, special programs will enhance your sporting life, whether you hit the track, the court, or the slopes.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karl Knopf\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Karl Knopf is the coordinator for the fitness therapist program at Foothill College of California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0